<template>
    <div v-if="show" :class="cn([
      'tw:flex tw:items-center tw:p-4 tw:mb-4 tw:rounded-lg',
      {
        'tw:text-gray-800 tw:bg-gray-50 tw:border tw:border-gray-200': variant === 'default',
        'tw:text-green-800 tw:bg-green-50 tw:border tw:border-green-200': variant === 'success',
        'tw:text-red-800 tw:bg-red-50 tw:border tw:border-red-200': variant === 'danger',
        'tw:text-yellow-800 tw:bg-yellow-50 tw:border tw:border-yellow-200': variant === 'warning',
        'tw:text-blue-800 tw:bg-blue-50 tw:border tw:border-blue-200': variant === 'info'
      }
    ], props.class)" role="alert">
        <div class="tw:flex-1 tw:flex tw:items-center">
            <div v-if="showIcon" class="tw:mr-3 tw:flex-shrink-0">
                <component :is="variantIcon" class="tw:w-5 tw:h-5" />
            </div>
            <div class="tw:flex-1 tw:text-sm tw:font-medium tw:[&_a]:underline">
                <slot></slot>
            </div>
        </div>
        <button v-if="dismissible" @click="dismiss" type="button"
            class="tw:ml-auto tw:-mx-1.5 tw:-my-1.5 tw:rounded-lg tw:p-1.5 tw:inline-flex tw:items-center tw:justify-center tw:h-8 tw:w-8 tw:transition-colors focus:tw:outline-none tw:cursor-pointer"
            :class="{
        'tw:text-gray-500 tw:hover:text-gray-800': variant === 'default',
        'tw:text-green-500 tw:hover:text-green-800': variant === 'success',
        'tw:text-red-500 tw:hover:text-red-800': variant === 'danger',
        'tw:text-yellow-500 tw:hover:text-yellow-800': variant === 'warning',
        'tw:text-blue-500 tw:hover:text-blue-800': variant === 'info'
      }">
            <span class="tw:sr-only">Dismiss</span>
            <X class="tw:w-4 tw:h-4 tw:stroke-[3]" />
        </button>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { X, Info, AlertCircle, CheckCircle2, AlertTriangle } from '@lucide/vue'
import {cn} from '@/shadcn/lib/utils'

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'success', 'danger', 'warning', 'info'].includes(value)
  },
  dismissible: {
    type: Boolean,
    default: false
  },
  showIcon: {
    type: Boolean,
    default: false
  },
  icon: {
    type: [String, Object],
    default: null
  },
  class: {
    type: String,
    default: ""
  },
})

const show = ref(true)

const variantIcon = computed(() => {
  // If a custom icon is provided, use it
  if (props.icon) {
    return props.icon
  }

  // Otherwise use the default variant icons
  switch (props.variant) {
    case 'success':
      return CheckCircle2
    case 'danger':
      return AlertCircle
    case 'warning':
      return AlertTriangle
    case 'info':
      return Info
    default:
      return Info
  }
})

const dismiss = () => {
  show.value = false
}
</script>
